let tempMode;

switch (window.location.origin) {
  case "https://www.esi.one":
  case "https://register.esi.logicflow.io":
    tempMode = "PROD";
    break;
  case "https://register.stage.esi.logicflow.io":
    tempMode = "STAGE";
    break;
  case "https://register.dev.esi.logicflow.io":
    tempMode = "DEV";
    break;
  default:
    tempMode = "DEV";
}

const mode =  tempMode;

export default {
  PUBLIC_ENDPOINT:
    mode === "PROD"
      ? "https://api.esi.logicflow.io/esi_public/esi_public/backend/"
      : mode === "STAGE"
      ? "https://api.esi.stage.logicflow.io/esi_public/esi_public/backend/"
      : "https://api.esi.dev.logicflow.io/esi_public/esi_public/backend/",

  PRIVATE_ENDPOINT:
    mode === "PROD"
      ? "https://api.esi.logicflow.io/esi_private/esi_private/backend/"
      : mode === "STAGE"
      ? "https://api.esi.stage.logicflow.io/esi_private/esi_private/backend/"
      : "https://api.esi.dev.logicflow.io/esi_private/esi_private/backend/",

  mode,
};
